import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Container } from './Container';
export const DraggableContainer = (_a) => {
    var _b;
    var { children, container } = _a, props = __rest(_a, ["children", "container"]);
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
        id: container.id,
    });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };
    const { label } = container;
    return (_jsx(Container, Object.assign({ dndSortableProps: { attributes, listeners, setNodeRef, style }, id: container.id, isOpen: (_b = container.isOpen) !== null && _b !== void 0 ? _b : true, label: label, ref: setNodeRef }, props, { children: children })));
};
//# sourceMappingURL=DraggableContainer.js.map